import { useEffect, useState } from 'react';
import { useModal } from '../../components/ModalProvider';
import { managerApi } from '../../lib/api';
import { DOC_TYPES } from '../../lib/constants';
import { applyTemplate } from '../../lib/format';
import { urlToDataUrl } from '../../lib/photo';
import { generateDocPDF } from '../../lib/pdf';

export function DocumentosMgrTab() {
  const { showModal, closeModal } = useModal();
  const [docs, setDocs] = useState<any[]>([]);
  const [employees, setEmployees] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ tipo: DOC_TYPES[0], titulo: '', target: 'todos', link: '', texto: '' });

  async function reload() {
    const [d, e] = await Promise.all([managerApi.listDocumentos(), managerApi.listEmployees()]);
    setDocs(d.documentos);
    setEmployees(e.employees);
  }
  useEffect(() => { setLoading(true); reload().finally(() => setLoading(false)); }, []);

  async function addDoc() {
    if (!form.titulo.trim() || (!form.texto.trim() && !form.link.trim())) { alert('Preencha o título e pelo menos o texto ou o link do documento.'); return; }
    await managerApi.addDocumento({ tipo: form.tipo, titulo: form.titulo.trim(), target: form.target, link: form.link.trim(), texto: form.texto.trim() });
    setForm({ tipo: DOC_TYPES[0], titulo: '', target: 'todos', link: '', texto: '' });
    await reload();
  }

  async function deleteDoc(id: string) {
    if (!confirm('Excluir este documento? As assinaturas registradas serão mantidas no histórico.')) return;
    await managerApi.deleteDocumento(id);
    await reload();
  }

  async function viewStatus(doc: any) {
    const res = await managerApi.getDocumentoStatus(doc.id);
    async function downloadFor(row: any) {
      const sigImg = row.signatureUrl ? await urlToDataUrl(row.signatureUrl) : null;
      generateDocPDF(doc, { nome: row.nome, cpf: row.cpf, funcao: row.funcao, camarote: row.camarote }, { nomeDigitado: row.nomeDigitado, assinadoEm: row.assinadoEm, hash: row.hash }, sigImg, applyTemplate);
    }
    showModal(<>
      <h2>{doc.titulo} <span className="pill pill-tag">{doc.tipo || 'Outro'}</span></h2>
      {doc.link && <p style={{ margin: '8px 0' }}><a className="maplink" href={doc.link} target="_blank" rel="noreferrer">Abrir documento original ↗</a></p>}
      {doc.texto && <div className="doc-text">{doc.texto}</div>}
      <hr className="div" /><h3 style={{ fontSize: 15 }}>Assinaturas</h3>
      {res.status.map((row: any) => (
        <div className="kv" key={row.employeeId}>
          <span>{row.nome}</span>
          <span>{row.signed ? <>✓ {new Date(row.assinadoEm).toLocaleString('pt-BR')} <button className="btn btn-ghost btn-sm" style={{ marginLeft: 6 }} onClick={() => downloadFor(row)}>PDF</button></> : 'Pendente'}</span>
        </div>
      ))}
      <button className="btn btn-ghost btn-block" style={{ marginTop: 14 }} onClick={closeModal}>Fechar</button>
    </>);
  }

  if (loading) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <>
      <div className="card">
        <h2>Novo documento</h2>
        <p className="hint">Cole o texto (do contrato, ficha, ASO etc.) ou cole um link, ou os dois. Use os marcadores abaixo para personalizar automaticamente com os dados de cada funcionário.</p>
        <div className="tags-hint">{'{{nome}} {{cpf}} {{pis}} {{endereco}} {{telefone}} {{pix}} {{funcao}} {{camarote}} {{valor_hora}} {{data}}'}</div>
        <label>Tipo de documento</label>
        <select value={form.tipo} onChange={(e) => setForm({ ...form, tipo: e.target.value })}>{DOC_TYPES.map((t) => <option key={t}>{t}</option>)}</select>
        <label>Título</label><input type="text" placeholder="Ex: Contrato de Trabalho — {{nome}}" value={form.titulo} onChange={(e) => setForm({ ...form, titulo: e.target.value })} />
        <label>Atribuir a</label>
        <select value={form.target} onChange={(e) => setForm({ ...form, target: e.target.value })}>
          <option value="todos">Todos os funcionários</option>
          {employees.map((e) => <option key={e.id} value={e.id}>{e.nome}</option>)}
        </select>
        <label>Link do documento original (opcional)</label><input type="text" placeholder="https://drive.google.com/..." value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value })} />
        <label>Texto do documento (opcional se já enviou o link)</label>
        <textarea placeholder="Cole aqui o texto completo, usando {{nome}}, {{cpf}} etc." value={form.texto} onChange={(e) => setForm({ ...form, texto: e.target.value })} />
        <button className="btn btn-primary btn-block" style={{ marginTop: 14 }} onClick={addDoc}>Publicar documento</button>
      </div>
      <div className="card">
        <h2>Documentos publicados</h2>
        {docs.length === 0 && <p className="hint">Nenhum documento ainda.</p>}
        {docs.map((d) => (
          <div className="doc-item" key={d.id}>
            <div>
              <div className="ttl">{d.titulo} <span className="pill pill-tag">{d.tipo || 'Outro'}</span></div>
              <div className="muted">{d.target === 'todos' ? 'Todos os funcionários' : (employees.find((e) => e.id === d.target)?.nome || '—')} · {d.signedCount}/{d.targetCount} assinado(s)</div>
            </div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button className="btn btn-ghost btn-sm" onClick={() => viewStatus(d)}>Ver</button>
              <button className="btn btn-danger btn-sm" onClick={() => deleteDoc(d.id)}>Excluir</button>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
